import React from "react"

function Books({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 55 55"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill="none"
        d="M 1.550388 3.359677 C 1.550388 2.660186 2.149952 2.060622 2.849443 2.060622 L 8.649771 2.060622 C 9.349262 2.060622 9.95034 2.660186 9.95034 3.359677 L 9.95034 20.860588 L 1.550388 20.860588 Z M 1.550388 3.359677 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill="none"
        d="M 5.750364 2.060622 L 5.750364 20.860588 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill="none"
        d="M 1.54736 5.859375 L 9.947312 5.859375 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill="none"
        d="M 1.545846 16.660612 L 9.945798 16.660612 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill="none"
        d="M 12.74982 2.160549 C 13.049602 2.060622 13.349384 2.060622 13.550753 2.160549 C 13.936836 2.225654 14.395593 2.687439 14.550026 3.159823 L 20.174724 18.921089 C 20.465422 19.54942 16.247277 20.544152 16.415337 20.406373 C 16.286642 20.088422 11.032887 4.03343 11.032887 4.03343 C 10.833032 3.333939 10.949614 2.760113 11.650619 2.460331 Z M 12.74982 2.160549 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill-opacity="1"
        fill="#000000"
        fill-rule="nonzero"
        d="M 11.711181 6.104651 L 15.19804 5.078125 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
      <path
        transform="matrix(2.58, 0, 0, 2.58, 0, 0.000002)"
        fill-opacity="1"
        fill="#000000"
        fill-rule="nonzero"
        d="M 15.423633 17.24655 L 18.949857 16.159461 "
        stroke="#003e4c"
        strokeWidth="0.75"
        strokeMiterlimit="4"
      />
    </svg>
  )
}
export default Books
